import { KeyboardArrowLeft } from '@mui/icons-material';
import { Button, type ButtonProps, IconButton } from '@mui/material';

import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint';

export type BackButtonProps<C extends React.ElementType> = ButtonProps<
  C,
  {
    component?: C;
  }
>;

export const BackButton = <C extends React.ElementType = 'button'>({ children, ...rest }: BackButtonProps<C>) => {
  const { isMobile } = useBreakpoint();

  if (!children) {
    return (
      <IconButton>
        <KeyboardArrowLeft />
      </IconButton>
    );
  }

  return (
    <Button startIcon={<KeyboardArrowLeft />} variant="text" size={isMobile ? 'medium' : 'large'} {...rest}>
      {children}
    </Button>
  );
};
